import { HttpErrorResponse } from '@angular/common/http';

/** i18n key of the generic «cannot reach the server» message (QA D-09). */
export const NETWORK_ERROR_KEY = 'COMMON.NETWORK_ERROR';

/**
 * The request never got an answer (no network, server down, aborted, CORS): `HttpErrorResponse` with `status === 0`.
 * With `withFetch()` its `error` is the browser's `TypeError` («Failed to fetch»), whose English, technical message
 * must not reach the user (QA D-09).
 */
export function isNetworkError(error: unknown): boolean {
  if (error instanceof HttpErrorResponse) return error.status === 0;
  if (error instanceof TypeError) return true;
  const candidate = error as { status?: unknown; error?: unknown } | null;
  return !!candidate && typeof candidate === 'object' && candidate.status === 0 && 'error' in candidate;
}
